import React from "react";

import AcumulateChartBar from "../../atoms/AcumulateChartBar";

import styles from "./AcumulateChart.module.scss";

interface AcumulateChartOption {
  height?: number;
  width?: number;
  firstAxisWidth?: number;
  lastAxisWidth?: number;
  nameWidth?: number;
}

const initialData: Required<AcumulateChartOption> = {
  height: 30,
  width: window.innerWidth - 40,
  firstAxisWidth: 100,
  lastAxisWidth: 40,
  nameWidth: 100,
};
interface categorySummary {
  color: string;
  value: number;
}
interface Summary {
  name: string;
  summaries: categorySummary[];
}

export interface AcumulateChartProps {
  dataSet: Summary[];
  options?: AcumulateChartOption;
}

const AcumulateChart = (props: AcumulateChartProps) => {
  if (props.dataSet.length === 0) {
    return null;
  }
  const options = { ...initialData, ...props.options };
  const max = Math.max.apply(
    null,
    props.dataSet.map(d =>
      d.summaries.reduce((total, cur) => (total += cur.value), 0),
    ),
  );
  const xGapValue =
    (options.width - (options.firstAxisWidth + options.lastAxisWidth)) / max;
  return (
    <div>
      {props.dataSet.map((d, idx) => {
        return (
          <div key={idx} className={styles.record}>
            <div className={styles.name} style={{ width: options.nameWidth }}>
              {d.name.length > 8 ? d.name.slice(0, 6) + "..." : d.name}
            </div>
            <svg
              version="1.1"
              width={options.width}
              height={options.height}
              xmlns="http://www.w3.org/2000/svg"
            >
              <AcumulateChartBar
                key={idx}
                xGapValue={xGapValue}
                height={options.height}
                dataSet={d.summaries}
              />
            </svg>
            <div className={styles.total}>
              {d.summaries.reduce((total, r) => (total += r.value), 0)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AcumulateChart;
